import React from 'react';
import Panel from './Panel';
import { IconUsers } from './icons';

function color(taux) {
  if (taux >= 0.8) return '#ef4444';
  if (taux >= 0.5) return '#f59e0b';
  return '#10b981';
}

/** Niveau d'affluence en temps réel par zone/arrêt. */
export default function CrowdingPanel({ data, delay = 0 }) {
  const stops = [...(data?.stops || [])].sort((a, b) => b.taux_occupation - a.taux_occupation);

  return (
    <Panel
      icon={IconUsers}
      title="Affluence en temps réel"
      sub="Taux d'occupation par zone"
      badge={`${stops.length} zones`}
      delay={delay}
    >
      {stops.length === 0 && <div className="empty">Aucune donnée d'affluence.</div>}
      {stops.map((s, i) => (
        <div className="crowd" key={s.zone_id}>
          <span className="crowd__name">{s.nom}</span>
          <span className="crowd__track">
            <span
              className="crowd__fill"
              style={{
                width: `${s.taux_occupation * 100}%`,
                background: color(s.taux_occupation),
                animationDelay: `${delay + i * 70}ms`,
              }}
            />
          </span>
          <span className="crowd__pct">{Math.round(s.taux_occupation * 100)}%</span>
        </div>
      ))}
    </Panel>
  );
}
